import urlExt from './url';
interface AppInfo {
  area: string;
  channel?: string;
  city: string;
  cuid: string;
  nt: string;
  os: string;
  province: string;
  token: string;
  vc: string;
  vcname: string;
  appid?: string;
  cname?: string;
  sdk?: number;
  imei?: string;
  devt?: string;
  brand?: string;
  device?: string;
  model?: string;
  lat?: string;
  lon?: string;
  accu?: string;
  gt?: number;
  ca?: number;
  density?: number;
}

interface LoginInfo {
  isLogin: boolean | number;
}

type Hybrid = (action: string, params?: any, callback?: () => unknown) => any; // eslint-disable-line

const get = (key: string): string | number => urlExt.getQuery(key);

export const ua: string = window && window.navigator ? window.navigator.userAgent : '';

export const inApp: boolean = ua ? /college/i.test(ua) : false;

export const isiOS: boolean = ua ? /iPad|iPhone/i.test(ua) : false;

export const isAndroid: boolean = ua ? /Android/i.test(ua) : false;

export const isHarmony: boolean = ua ? /Harmony/i.test(ua) : false;

export const isInHomeWork = /homework/i.test(navigator.userAgent);

export const isInKd = ua ? /scancode|kuaidui/i.test(ua) : false; // 快对

export const isInWakeup = ua ? /wakeup/i.test(ua) : false; // wakeup

export const vc = (function () {
  const matchList = /college_vc\/(\d+)/g.exec(ua.toLowerCase());
  return matchList !== null && matchList.length >= 2 ? matchList[1] : '';
})();

export async function getNAAppInfo(hybrid: Hybrid): Promise<{ [key: string]: any }> {  //  eslint-disable-line
  if (inApp) {
    let appInfo: AppInfo | null = null;
    await new Promise(resolve => hybrid('common', resolve)).then(res => {
      appInfo = res as AppInfo;
    });
    return appInfo || {};
  } else {
    return {}
  }
}

export async function getLoginInfo(hybrid: Hybrid): Promise<number | boolean> {
  let loginInfo: LoginInfo = { isLogin: false };
  await new Promise(resolve => hybrid('is_login', resolve)).then(res => {
    loginInfo = res as LoginInfo;
  });
  return loginInfo.isLogin;
}

export async function getAppInfo(hybrid: Hybrid): Promise<{ [key: string]: any }> { // eslint-disable-line
  let appInfo: {[index: string]: any} = {}  // eslint-disable-line
  if (inApp) {
    appInfo = await getNAAppInfo(hybrid);
    appInfo.isLogin = await getLoginInfo(hybrid);
  } else {
    ['area', 'channel', 'city', 'cuid', 'nt', 'os', 'province', 'token', 'vc', 'vcname'].forEach(item => {
      appInfo[item] = get(item);
    });
    appInfo.isLogin = get('login');
  }
  return appInfo;
}
